module.exports = __webpack_public_path__ + "img/123.f8348a79.jpg";